<template>
    <div>
        <div v-if="isLoading" class="loading-state">
            <p>Loading...</p>
        </div>

        <!-- If authorized, the Login component is rendered -->
        <login v-if="isAuthorized"></login>
        <div v-else></div>
    </div>

</template>

<script>
import Login from './login.vue';

export default {
    name: 'Gatekeeper',
    components: {
        'login': Login
    },
    data: function () {
        return {
            isLoading: true,
            isAuthorized: false
        };
    },
    created: function () {
        this.verifyNetworkAccess();
    },
    methods: {
        verifyNetworkAccess: async function () {
            var self = this;

            // Using fetch (or you can swap for this.$http/axios if preferred in your Vue 2 setup)
            const userIP = await fetch('/api/user/checkIP', {method: 'POST'}).then(response => {
                self.isAuthorized = response.ok
            })

            self.isLoading = false
        }
    }
};
</script>

<style scoped>
.loading-state {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    font-family: Arial, sans-serif;
    color: #666;
}
</style>
